import { history } from '../../helpers/History'
import { ApplicationCloseReason } from '../index'
import { StoreModel } from '../../models/Index'

import { RoutePaths } from 'helpers'
import { Payment } from '../../interfaces/Payment';

export default async function goPayment(Store: StoreModel, data: any, event: any) {
  const payment = data.data as Payment
  const customer = payment.billpayResponse;

  if (!customer) {
    const error = new Error('No customer data!')
    console.error(error, customer)

    throw error
  }

  Store.billpay.setCustomerData(customer);
  Store.setPaymentAttributes(payment);

  //Closing app
  return Store.sdk.closeApp(ApplicationCloseReason.GoToPayment)
    .then(() => {
      history.push({
        pathname: RoutePaths.CashAccepterStep,
        search: history.location.search
      })
  })
    
}
